// extracted by mini-css-extract-plugin
export default {"highlights":"styles_highlights__asixZ","title":"styles_title__uoSt7","disclaimer":"styles_disclaimer__pI4Z-","valueItemWidth":"styles_valueItemWidth__QxTne"};